import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

export function Layout({
  adminEmail,
  children,
  notice,
  onSignOut
}: {
  adminEmail?: string;
  children: ReactNode;
  notice?: { tone: "error" | "success"; text: string } | null;
  onSignOut?: () => void;
}) {
  return (
    <main className="shell">
      <aside className="side">
        <div className="brand">
          <img alt="Tesflows" className="sideLogo" src="/logo.png" />
          <div>
            <span className="brandName"><span className="brandNameTes">Tes</span><span className="brandNameFlows">flows</span></span>
            <span>admin.tesflows.com</span>
          </div>
        </div>
        <nav className="nav">
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/invitations">Invitations</NavLink>
          <NavLink to="/users">Users & rows</NavLink>
          <NavLink to="/runs">Runs</NavLink>
          <NavLink to="/workflows">Workflows</NavLink>
          <NavLink to="/logs">Logs</NavLink>
        </nav>
        {adminEmail ? (
          <div className="account">
            <span>Signed in</span>
            <strong>{adminEmail}</strong>
            <button onClick={onSignOut} type="button">Sign out</button>
          </div>
        ) : null}
      </aside>
      <section className="main">
        {notice ? <div className={`notice ${notice.tone}`}>{notice.text}</div> : null}
        {children}
      </section>
    </main>
  );
}
